// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"aa9d243a","425":"6c685017","703":"fc7b16a8"}[chunkId] + ".chunk.js";
};